<template>
  <div id="feedChooseTitle">
    <div v-for="item in feedTitle" :key="item.id" class="foodChoose-title">
      <img :src="item.img" alt=""/>
    </div>
    <div v-if="showMore" class="foodChoose-more">
      <img alt="更多" src="@/assets/images/babyFeeding/more.png"/>
      <div class="trap">
        <openWxTag :id="'xmyxTitle'+feedTitle[0].id" btnStyle="width:100%;height:17px" path="/pages/index/index"></openWxTag>
      </div>
    </div>
  </div>
</template>
<script>
import {goToMini, TestUserAgent} from "@/assets/js/common.js";
import openWxTag from "@/components/common/openWeappTag/index.vue"; // 打开小程序开放标签
export default {
  name: "feedChooseTitle",
  data() {
    return {
      isSystem: '',
    };
  },
  props: {
    titleList: {
      type: Array,
      default: () => {
        return [
          {id: 0, img: require("@/assets/images/babyFeeding/StartFood.png")},
          {id: 1, img: require("@/assets/images/babyFeeding/babyMother.png")},
          {id: 2, img: require("@/assets/images/babyFeeding/starFeed.png")},
        ];
      },
    },
    title: {type: Number, default: 0},
    showMore: {
      type: Boolean,
      default: true
    },
  },
  components: {openWxTag},
  mounted() {
    this.isSystem = TestUserAgent().isios;  },
  methods: {
    goToMini
  },
  computed: {
    feedTitle() {
      return this.titleList.filter((item) => item.id == this.title);
    }, //用对应的id过滤数组
  },
};
</script>
<style lang="less" scoped>
#feedChooseTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 11px;

  .foodChoose-title {
    margin-top: 19px;
    height: 17px;

    img {
      height: 100%;
      margin-right: 6px;
    }
  }

  .foodChoose-more {
    width: 30px;
    height: 16px;
    margin-top: 16px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.trap {
  width: 32px;
  height: 17px;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 99;
}
</style>
